<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('importDonneIdelia.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <qd-message
      :title="$t('importDonneIdelia.info.title')"
      class="mgt-20px"
      type="is-info">
      <span v-html="$t('importDonneIdelia.info.message')"></span>
    </qd-message>
    <div class="columns is-multiline mgt-20px">
      <import-card
        v-for="dataType in constantes.IMPORT_DATA_TYPE"
        :key="dataType.type"
        v-bind="dataType">
      </import-card>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import importCard from '@/components/configInterne/importData/importCard';
import { IMPORT_DATA_TYPE } from '@/configuration/import/importIdeliaConfig';

export default {
  name: 'ImportIdelia',
  components: {
    breadcrumb,
    importCard,
  },
  data() {
    return {
      constantes: {
        IMPORT_DATA_TYPE,
      },
    };
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('importDonne.breadcrumb.config'), route: '', isActive: true },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.importIdelia.import'));
  },
};
</script>
